export const priceFormat = (price?: number): string => {
  if (!price) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: price % 1 === 0 ? 0 : 2, // No decimals if it's a whole number
  }).format(price);
};

export const rateTransform = (rate: number | undefined, lang: string) => {
  if (rate == null) return ''; // return empty string if undefined or null
  if (lang === 'fr') return rate.toFixed(2).replace('.', ',');
  return rate.toFixed(2);
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const numberFormatter = (
  number: number | null | undefined,
  language: string,
): string | null | undefined => {
  if (number === null || number === undefined) {
    return null;
  }
  if (language === 'fr') {
    return `${new Intl.NumberFormat().format(Math.round(number)).replace(',', ' ')} $`;
  }
  return formatter.format(number);
};
